import { IntersectionRuleConfiguration } from "./IntersectionRuleConfiguration";
import { IntersectionRuleEditContext } from "./IntersectionRuleEditContext";
import { TestResultDataType } from "../../Common/Testing/TestResultDataType";
import { BaseTestResultData } from "../../Common/Testing/BaseTestResultData";

export class IntersectionRuleTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.INTERSECTION_RULE;
    editContext?: IntersectionRuleEditContext;

    private _definition?: IntersectionRuleConfiguration;

    get definition(): IntersectionRuleConfiguration | undefined {
        return this._definition;
    }

    set definition(definition: IntersectionRuleConfiguration | undefined) {
        this._definition = definition;

        if (this._definition) {
            this.editContext = new IntersectionRuleEditContext(this._definition);
        }
    }
}

export class IntersectionXRuleTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.INTERSECTION_X_RULE;
}

export class IntersectionYRuleTestResult extends BaseTestResultData {
    type: TestResultDataType = TestResultDataType.INTERSECTION_Y_RULE;
}
